const STORAGE_KEY = 'ofrontend.workerAvatarByEmail';

function readAvatarMap(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    const map: Record<string, string> = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof key === 'string' && typeof value === 'string' && value.trim()) {
        map[key.trim().toLowerCase()] = value.trim();
      }
    }
    return map;
  } catch {
    return {};
  }
}

function writeAvatarMap(map: Record<string, string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota */
  }
}

/** Shared worker photo hints keyed by worker email (survives employer vs worker login on one device). */
export function loadWorkerAvatarByEmail(email: string | null | undefined): string | null {
  const normalized = email?.trim().toLowerCase();
  if (!normalized) {
    return null;
  }
  return readAvatarMap()[normalized] ?? null;
}

export function persistWorkerAvatarByEmail(
  email: string | null | undefined,
  avatarSrc: string,
): void {
  const normalized = email?.trim().toLowerCase();
  const src = avatarSrc.trim();
  if (!normalized || !src) {
    return;
  }
  const map = readAvatarMap();
  map[normalized] = src;
  writeAvatarMap(map);
}
